import type { ContainerProps } from '@mui/material/Container';

import Container from '@mui/material/Container';

// ----------------------------------------------------------------------

export type PageVariant = 'data' | 'form';

/** NAT-2711 — the cap a form keeps; the theme's `lg` breakpoint (1200 px). */
export const FORM_MAX_WIDTH = 'lg' as const;

export type PageContainerProps = Omit<ContainerProps, 'maxWidth'> & {
  /**
   * `data`: lists, details, dashboards, stats, order editors — the whole width beside the sidebar.
   * `form`: create/edit forms — capped at FORM_MAX_WIDTH and left-aligned.
   * Required: every page decides.
   */
  variant: PageVariant;
};

export function PageContainer({ variant, sx, ...other }: PageContainerProps) {
  return (
    <Container
      data-page-variant={variant}
      maxWidth={variant === 'form' ? FORM_MAX_WIDTH : false}
      sx={[variant === 'form' && { mx: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    />
  );
}
